var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBottomWaves(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1446,
    height: 148,
    viewBox: "0 0 1446 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1446 111.891C1331.68 146.412 1117.04 175.315 867.751 100.747C656.273 37.5048 283.928 35.4209 15.0625 33.5182V9.32664H1446V111.891Z",
    fill: "#D70E90"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1446 78.0958C1359.84 117.418 1104.53 171.781 812.019 87.3375C661.093 43.7565 459.105 33.5181 316.614 33.5181C174.123 33.5181 45.7899 33.5181 0 33.5181C0 19.4743 0 14.2193 0 0.266098H1446V78.0958Z",
    fill: "#002853"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomWaves);
export default __webpack_public_path__ + "static/media/bottomWaves.bb4a9fd74a9582690b2600e53ff5d66c.svg";
export { ForwardRef as ReactComponent };